import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { visitsApi } from '@/api/visits';
import type { CheckOutPayload } from '@/api/visits';

function getErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    return error.message;
  }
  const axiosError = error as { response?: { data?: { message?: string } } };
  if (axiosError.response?.data?.message) {
    return axiosError.response.data.message;
  }
  return 'Произошла ошибка';
}

export function useActiveVisit(pollingInterval = 60_000) {
  return useQuery({
    queryKey: ['visits', 'active'],
    queryFn: visitsApi.getActiveVisit,
    refetchInterval: pollingInterval,
    staleTime: 30_000,
  });
}

export function useCheckIn() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ clientId, note }: { clientId: number; note?: string }) =>
      visitsApi.checkIn(clientId, note),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['visits', 'active'] });
      queryClient.invalidateQueries({ queryKey: ['visits', 'weekly'] });
      queryClient.invalidateQueries({ queryKey: ['clientWeeklyVisits'] });
      queryClient.invalidateQueries({ queryKey: ['client-detail'] });
    },
    onError: (error) => {
      toast.error('Ошибка начала визита', { description: getErrorMessage(error) });
    },
  });
}

export function useCheckOut() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload?: CheckOutPayload) => visitsApi.checkOut(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['visits', 'active'] });
      queryClient.invalidateQueries({ queryKey: ['visits', 'weekly'] });
      queryClient.invalidateQueries({ queryKey: ['clientWeeklyVisits'] });
      queryClient.invalidateQueries({ queryKey: ['client-detail'] });
      queryClient.invalidateQueries({ queryKey: ['visitHistory'] });
    },
    onError: (error) => {
      toast.error('Ошибка завершения визита', { description: getErrorMessage(error) });
    },
  });
}
